<template>
  <div class="contactItem">
    <div @mouseover="mouseOver1" @mouseleave="mouseLeave1">
      <img src="../assets/qq.png" alt="" />
      <div class="box" v-show="boxShow1">
        <span>在线服务咨询</span>
        <span>专属商务经理在线解答</span>
      </div>
    </div>
    <div @mouseover="mouseOver2" @mouseleave="mouseLeave2">
      <img src="../assets/wx.png" alt="" />
      <div class="boxVx" v-show="boxShow2">
        <span>微信关注我们</span>
        <img src="../assets/erweimaZ.png" alt="" />
      </div>
    </div>
    <div @mouseover="mouseOver3" @mouseleave="mouseLeave3">
      <img src="../assets/telephone.png" alt="" />
      <div class="box" v-show="boxShow3">
        <span>售前电话咨询</span>
        <span>186-3037-6696</span>
      </div>
    </div>
    <div @mouseover="mouseOver4" @mouseleave="mouseLeave4" @click="clickParent">
      <img src="../assets/xx.png" alt="" />
      <div class="box" v-show="boxShow4">
        <span>在线留言咨询</span>
        <span>获取售前专业咨询</span>
      </div>
      <ZXDialog ref="mychild" />
    </div>
  </div>
</template>

<script>
import ZXDialog from "./ZXDialog";
export default {
  name: "contactItem",
  components: { ZXDialog },
  data() {
    return {
      dialogShow: false,
      boxShow1: false,
      boxShow2: false,
      boxShow3: false,
      boxShow4: false
    };
  },
  methods: {
    mouseOver1() {
      this.boxShow1 = true;
      console.log(this.boxShow1);
    },
    mouseLeave1() {
      this.boxShow1 = false;
    },
    mouseOver2() {
      this.boxShow2 = true;
    },
    mouseLeave2() {
      this.boxShow2 = false;
    },
    mouseOver3() {
      this.boxShow3 = true;
    },
    mouseLeave3() {
      this.boxShow3 = false;
    },
    mouseOver4() {
      this.boxShow4 = true;
    },
    mouseLeave4() {
      this.boxShow4 = false;
    },
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    }
  }
};
</script>

<style scoped>
.contactItem {
  width: 60px;
  height: 304px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 0px 30px 0px rgba(89, 98, 107, 0.12);
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 597px;
  right: 46px;
  z-index: 999;
  padding-top: 20px;
}
.contactItem img {
  display: block;
  width: 36px;
  height: 36px;
  margin-bottom: 20px;
}
.contactItem > div {
  margin: 0 auto;
  padding: 0 8px;
  margin-bottom: 19px;
  border-bottom: 1px solid #e8f1f7;
  cursor: pointer;
  position: relative;
}
.contactItem > div:last-child {
  border-bottom: 0;
}
.box {
  width: 212px;
  height: 66px;
  background-image: url("~../assets/qqBanner.png");
  background-repeat: no-repeat;
  position: absolute;
  top: -15px;
  right: 68px;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-top: 10px;
  z-index: 999999;
  /* display: none; */
}
.box span:first-child {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 5px;
}
.box span:last-child {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.boxVx {
  width: 212px;
  height: 221px;
  background-image: url("~../assets/vxBanner.png");
  background-repeat: no-repeat;
  position: absolute;
  top: -15px;
  right: 68px;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 12px;
  z-index: 999999;
}
.boxVx span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 10px;
  margin-left: -10px;
}
.boxVx img {
  display: block;
  width: 162px;
  height: 162px;
  margin: 0 auto;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactItem.vue